import React, { useEffect, useState } from 'react';

import {
  Stack, Typography, useTheme,
} from '@mui/material';

import Chip from '../../../../components/Chip';
import ContentCard from '../../../../components/ContentCard';
import ProfileIcon from '../../../../components/ProfileIcon';
import { Lead } from '../../../../services/leads/types';
import { LeadType } from '../../../../types/common';
import { joinNames } from '../../../../utils/common/formatText';

interface ProfileCardProps {
  lead?: Lead,
}

const ProfileCard = ({ lead }: ProfileCardProps) => {
  const theme = useTheme();

  const [displayedName, setDisplayedName] = useState<string>('');

  useEffect(() => {
    if (lead?.name && lead?.parentName) {
      setDisplayedName(joinNames([lead?.name, lead?.parentName ? `(P: ${lead?.parentName})` : undefined]));
    } else if (lead?.name) {
      setDisplayedName(lead?.name);
    } else {
      setDisplayedName('Unknown');
    }
  }, [lead]);

  return (
    <ContentCard>
      <Stack direction="row" spacing={2} alignItems="center">
        <ProfileIcon
          firstName={lead?.firstName}
          lastName={lead?.lastName}
          size={96}
        />
        <Stack direction="column" spacing={1}>
          <Typography variant="h4" color={theme.palette.darkPrimary.main}>{displayedName}</Typography>
          <Stack direction="row" spacing={1}>
            {lead?.type === LeadType.Enrolment &&
            <Chip color="lightOrange" label="Enrolment" />}
            {lead?.type === LeadType.Contact &&
            <Chip color="lightRed" label="Contact" />}
          </Stack>
        </Stack>
      </Stack>
    </ContentCard>
  );
};

export default ProfileCard;
